/**
 * Instagram Banner — QR code on desktop + sarcastic CTA + big follow button.
 * Mobile shows the button bigger and hides the QR (you can't scan your own phone).
 */
import React from 'react';
import { Instagram, ArrowUpRight, Sparkles } from 'lucide-react';
import { analytics } from '../../services/analytics';
import './InstagramBanner.css';

const INSTAGRAM_URL = 'https://www.instagram.com/quitameloporquemelogasto?igsh=ZHRteHYydWlreGVz&utm_source=qr';
const QR_IMAGE = 'https://customer-assets.emergentagent.com/job_ahorro-constante/artifacts/ziboeqqr_IMG_8245.jpeg';

const handleClick = () => {
  analytics.ctaClick('instagram_banner');
};

const InstagramBanner = () => (
  <section className="section ig-banner-section" data-testid="instagram-banner">
    <div className="ig-banner">
      <div className="ig-banner-glow" aria-hidden="true" />

      <div className="ig-banner-content">
        <div className="ig-banner-badge">
          <Sparkles className="w-4 h-4" />
          <span>Reels que duelen (un poco) pero educan</span>
        </div>

        <h2 className="ig-banner-title">
          Síguenos en <span className="ig-banner-brand">Instagram</span>
        </h2>

        <p className="ig-banner-subtitle">
          Tips de ahorro, sarcasmo financiero y recordatorios para que no te gastes el bono.
          Cero spam, puro contenido que te hace pensar dos veces antes del próximo "carrito" 🛒
        </p>

        <div className="ig-banner-handle">@quitameloporquemelogasto</div>

        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          className="ig-banner-button"
          data-testid="instagram-banner-button"
        >
          <Instagram className="w-5 h-5" />
          <span>Seguir en Instagram</span>
          <ArrowUpRight className="w-4 h-4 ig-banner-arrow" />
        </a>
      </div>

      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className="ig-banner-qr-wrap"
        aria-label="Escanea el código QR para seguirnos en Instagram"
        data-testid="instagram-banner-qr"
      >
        <img
          src={QR_IMAGE}
          alt="Código QR para seguir a @quitameloporquemelogasto en Instagram"
          className="ig-banner-qr"
          loading="lazy"
          width="280"
          height="430"
        />
        <span className="ig-banner-qr-hint">
          📱 Escanéame desde tu cámara
        </span>
      </a>
    </div>
  </section>
);

export default InstagramBanner;
